import React, { useEffect, useState } from "react";
import { userApi } from "../../../../services";

const styles = {
  container: {
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  pagination: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  error: {
    color: "red",
  },
};

const Passbook = () => {
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const totalPages = Math.ceil(total / limit);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      setError("");

      const accountNumber = localStorage.getItem('accountNumber');
      // const res = await userApi.getMyTransactions({ page, limit });
      // const res = await userApi.getMyTransactions(accountNumber);
	const res = await userApi.getMyTransactions(accountNumber, page, limit);

      setTransactions(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      setError("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [page]);

  return (
    <div style={styles.container}>
      <h2>Passbook</h2>

      {loading && <p>Loading transactions...</p>}
      {error && <p style={styles.error}>{error}</p>}

      {!loading && transactions.length === 0 && (
        <p>No transactions found</p>
      )}

      {!loading && transactions.length > 0 && (
        <>
          <table style={styles.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Balance</th>
                {/* <th>Description</th>*/}
              </tr>
            </thead>

            <tbody>
              {transactions.map((txn) => (
                <tr key={txn._id}>
                  <td>{new Date(txn.createdAt).toLocaleString()}</td>

                  <td
                    style={{
                      color:
                        txn.type === "credit" ? "green" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {txn.type.toUpperCase()}
                  </td>

                  <td>₹ {txn.amount}</td>
                  <td>₹ {txn.newBalance}</td>
                  {/* <td>{txn.description || "-"}</td>*/}
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div style={styles.pagination}>
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              Page {page} of {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Passbook;
